// extracted by mini-css-extract-plugin
export default {"wrap":"notfound_wrap__Mg1NN"};